<div class="smp-table-container">

    <div class="row no-gutters smp-table-header">
        <div class="col-sm-2 smp-table-column">
            {{ 'common.label.date' | translate }}
        </div>

        <div class="col-sm-2 smp-table-column">
            {{ 'common.label.user' | translate }}
        </div>

        <div class="col-sm-2 smp-table-column">
            {{ 'common.label.category' | translate }}
        </div>

        <div class="col-sm-2 smp-table-column">
            {{ 'common.label.action' | translate }}
        </div>

        <div class="col-sm-4 smp-table-column">
            {{ 'common.label.additional_info' | translate }}
        </div>
    </div>

    <div class="smp-table-rows-scrollable">

        <div class="row no-gutters smp-table-row" *ngFor="let log of logs?.items">
            <div class="col-sm-2 smp-table-column center">
                {{ log.log_datetime | drDateTime }}
            </div>

            <div class="col-sm-2 smp-table-column center">
                {{ log.user_name }}
            </div>

            <div class="col-sm-2 smp-table-column center">
                {{ log.category }}
            </div>

            <div class="col-sm-2 smp-table-column center">
                {{ log.action }}
            </div>

            <div class="col-sm-4 smp-table-column left">
                {{ log.message || '-' }}
            </div>
        </div>

    </div>

</div>
